import { render, staticRenderFns } from "./payment-source-details.vue?vue&type=template&id=36fba96c&scoped=true"
import script from "./payment-source-details.vue?vue&type=script&lang=ts"
export * from "./payment-source-details.vue?vue&type=script&lang=ts"
import style0 from "./payment-source-details.vue?vue&type=style&index=0&id=36fba96c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fba96c",
  null
  
)

export default component.exports